

































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































interface taxTypes {
    id: number;
    name: string;
    code: string;
}
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { mapGetters } from "vuex";
// 引入表格数据
import vatDeclaration from "./vatDeclaration";
import NormalMain from "./NormalMain";
import salesdetails from "./salesdetails";
import inputtaxdetails from "./inputtaxdetails";
import Appendix3, { Appendix3Data } from "./Appendix3";
import fourRowTable from "./fourRowTable";
import { watch } from "fs";
@Component({
    ...mapGetters(["accountBook"]),
    components: {}
})
export default class DecTable extends Vue {
    @Prop({ type: String })
    activeTab?: string;

    @Prop({ type: Boolean, default: false })
    isSave?: boolean;

    @Prop({ type: Object })
    curData!: Declaration.Declaration;

    @Prop({ type: Object })
    vatCut!: any;

    @Watch("isSave")
    saveChange(val: Boolean) {
        console.log(val)
    }

    // 免税表下拉
    vatcuter: taxTypes[]=[
        {
            id: 1,
            name:
                "小规模纳税人3%征收率销售额免征增值税|《财政部 税务总局关于对增值税小规模纳税人免征增值税的公告》 财政部 税务总局公告2022年第15号",
            code: "0001045308|SXA031901259"
        },
        
    ]

    // 减免税表下拉
    taxTypes: taxTypes[] = [
        {
            id: 21,
            name:
                "《财政部 税务总局关于明确增值税小规模纳税人减免增值税等政策的公告》 财政部 税务总局公告2023年第1号第二条",
            code: "SXA031901121"
        },
        {
            id: 1,
            name:
                "《财政部 国家税务总局关于推广税控收款机有关税收政策的通知》财税[2004]167号",
            code: "SXA031900185"
        },
        {
            id: 2,
            name:
                "《国家税务总局关于增值税税控系统专用设备和技术维护费用抵减增值税税额有关政策的通知》财税[2012]15号",
            code: "SXA031900185"
        },
        {
            id: 3,
            name:
                "《财政部 国家税务总局关于部分货物适用增值税低税率和简易办法征收增值税政策的通知》财税[2009]9号第二条（一）、（二）项",
            code: "SXA031900512"
        },
        {
            id: 4,
            name:
                "《财政部 国家税务总局关于简并增值税征收率政策的通知》财税[2014]57号第一条",
            code: "SXA031900512"
        }, {
            id: 20,
            name:
                "《财政部 税务总局关于支持个体工商户复工复业增值税政策的公告》财政部 税务总局公告2020年第13号",
            code: "SXA031901121"
        }
    ];

    rowData: vatDeclaration[] = vatDeclaration.list;
    genRow: NormalMain[] = NormalMain.list; //一般 主表
    salesRow: salesdetails[] = salesdetails.list; //附表一
    inputRow: inputtaxdetails[] = inputtaxdetails.list; //附表二
    fourRow: fourRowTable[] = fourRowTable.list; //附表四
    newSeri: string = "";
    newSeri2: string = "";
    newType: number | null = null;
    newNum1: string = "";
    newNum2: string = "";
    newNum4: string = "";
    nextNewType: number | null = null;
    nextNewNum1: string = "";
    nextNewNum2: string = "";
    nextNewNum4: string = "";
    nextNewNum5: string = "";

    mounted() {
        this.getData();
    }

    // 主表input change
    changeVal(row: vatDeclaration) {
        this.$emit("change", row);
    }
    canEdit(row: any, col: number, isLine: boolean) {
        if (
            ((col >= 1 && col <= 8) || col === 14) &&
            !isLine &&
            (row.content.row <= 6 || row.content.row === 21 || row.content.row === 22 || row.content.row === 8 || row.content.row === 12 || row.content.row === 9|| row.content.row === 10 || row.content.row === 11 || row.content.row === 13)
        )
            return true;
        else return false;
    }

    selectInner(e: any) {
        this.$nextTick(() => {
            e.target.select();
        });
    }

    focusInner(e: any) {
        e.target.select();
    }

    @Watch("curData", { deep: true })
    dataChange() {
        this.newType = null;
        this.nextNewType = null;
        if (
            this.activeTab === "vatDeclaration" ||
            this.activeTab === "salesdetails" ||
            this.activeTab === "generaltaxpayervatdeclaration" ||
            this.activeTab === "inputtaxdetails" ||
            this.activeTab === "isAppendix4" ||
            this.activeTab === "isAppendix3"
        ) {
            this.getData();
        }
    }
    // 获取表格数据
    getData() {
        if (this.curData) {
            if (this.activeTab === "vatDeclaration") {
                if (this.curData.currentGoods) {
                    this.curData.currentGoods.forEach(
                        (v: string, i: number) => {
                            let val = ""; // 小规模 主表
                            // if (this.rowData[i].oneEdit)
                            //     val = this.$utils.currency(v);
                            // else 
                            val = v;
                            this.rowData[i].val1 = val;
                        }
                    );
                    if (this.curData.currentService) {
                        this.curData.currentService.forEach(
                            (v: string, i: number) => {
                                let val = "";
                                // if (this.rowData[i].twoEdit)
                                //     val = this.$utils.currency(v);
                                // else 
                                val = v;
                                this.rowData[i].val2 = val;
                            }
                        );
                    }
                    if (this.curData.totalGoods)
                        this.curData.totalGoods.forEach(
                            (v: string, i: number) => {
                                this.rowData[i].val3 = v;
                            }
                        );
                    if (this.curData.totalService)
                        this.curData.totalService.forEach(
                            (v: string, i: number) => {
                                this.rowData[i].val4 = v;
                            }
                        );
                }
            }
            // 一般 主表
            if (this.activeTab === "generaltaxpayervatdeclaration") {
                if (this.curData.generalMonthBalance) {
                    this.curData.generalMonthBalance.forEach(
                        (v: string, i: number) => {
                            let val = "";
                            if (this.genRow[i].val1 != "--") val = v;
                            else val = this.genRow[i].val1;
                            this.genRow[i].val1 = val;
                        }
                    );
                    this.curData.generalYearBalance.forEach(
                        (v: string, i: number) => {
                            let val = "";
                            if (this.genRow[i].val2 != "--") val = v;
                            else val = this.genRow[i].val2;
                            this.genRow[i].val2 = val;
                        }
                    );
                }
            }
            // 附表一
            if (this.activeTab === "salesdetails") {
                if (this.curData.data) {
                    this.curData.data.forEach(
                        (v: Declaration.Data, i: number) => {
                            v.content = this.salesRow[i];
                        }
                    );
                }
            }
            // 附表二
            if (this.activeTab === "inputtaxdetails") {
                if (this.curData.inputTaxDetailRowDtos) {
                    this.curData.inputTaxDetailRowDtos.forEach(
                        // @ts-ignore
                        (v: Declaration.InputTaxDetailRowDtos, i: number) => {
                            this.inputRow.forEach((r: any, j: number) => {
                                if (r.row === v.row) {
                                    Object.keys(v).forEach(attr => {
                                        // @ts-ignore
                                        r[attr] = v[attr];
                                    });
                                }
                            });
                        }
                    );
                }
            }
            if (this.activeTab === "isAppendix3") {
                // 附表三
                if (this.curData.data) {
                    this.curData.data.forEach((v: any, i: number) => {
                        Object.keys(v).forEach(attr => {
                            // @ts-ignore
                            this.appendix3[i][attr] = v[attr];
                        });
                    });
                }
            }
            if (this.activeTab === "isAppendix4") {
                // 附表四
                if (this.curData.data) {
                    this.fourRow.forEach((v, i) => {
                        if (!v.isHead) {
                            // @ts-ignore
                            v.initBalance = this.curData.data[v.index].initBalance;
                            // @ts-ignore
                            v.balance = this.curData.data[v.index].balance;
                            // @ts-ignore
                            v.deductBalance = this.curData.data[v.index].deductBalance;
                            // @ts-ignore
                            v.countBalance = this.curData.data[v.index].countBalance;
                            // @ts-ignore
                            v.actualBalance = this.curData.data[v.index].actualBalance;
                            // @ts-ignore
                            v.endBalance = this.curData.data[v.index].endBalance;
                            // @ts-ignore
                            v.accountBookId = this.curData.data[v.index].accountBookId;
                            // @ts-ignore
                            v.startPeriod = this.curData.data[v.index].startPeriod;
                            // @ts-ignore
                            v.endPeriod = this.curData.data[v.index].endPeriod;
                            // @ts-ignore
                            v.id = this.curData.data[v.index].id;
                            // @ts-ignore
                            v.type = this.curData.data[v.index].type;
                        }
                    });
                }
            }
        }
    }

    // 删除增值税减免税申报的行
    deleteRow(row: any) {
        this.$confirm(`亲，确定要删除这条记录吗？`, "温馨提示").then(
            (action: any) => {
                if (action === "confirm") {
                    Vue.axios
                        .delete(`vatcutdeclarations`, {
                            params: {
                                id: row.id
                            }
                        })
                        .then(res => {
                            this.$emit("update");
                        });
                }
            }
        );
    }
    deleteCutRow(row: any) {
        this.$confirm(`亲，确定要删除这条记录吗？`, "温馨提示").then(
            (action: any) => {
                if (action === "confirm") {
                    Vue.axios
                        .delete(`vatcutdeclarationextras`, {
                            params: {
                                id: row.id
                            }
                        })
                        .then(res => {
                            this.$emit("update");
                        });
                }
            }
        );
    }

    // 减免税表 两种数据 提交
    saveNew() {
        if (this.newNum2 != "" || this.newNum4 != "" || this.newNum1 != "") {
            if (this.curData) {
                if (this.newNum2 === "") this.newNum2 = "0"
                if (this.newNum1 === "") this.newNum1 = "0"
                if (this.newNum4 === "") this.newNum4 = "0"
                Vue.axios
                    .post(`vatcutdeclarations`, {
                        accountBookId: this.$store.state.accountBook.id,
                        startPeriod: this.curData.startPeriod,
                        endPeriod: this.curData.endPeriod,
                        no: this.newSeri,
                        type: this.newType,
                        initBalance: this.newNum1,
                        balance: this.newNum2,
                        actualBalance: this.newNum4
                    })
                    .then(res => {
                        this.$emit("update");
                        this.newNum1 = this.newNum2 = this.newNum4 = "";
                        this.newType = this.taxTypes[0].id;
                    });
            }
        } else {
            this.$message("亲,请将三种数额全部填写");
        }
    }
    saveNewbtm() {
        if (this.nextNewNum2 != "" || this.nextNewNum4 != "" || this.nextNewNum1 != "" || this.nextNewNum5 != "") {
            if (this.vatCut) {
                if (this.nextNewNum2 === "") this.nextNewNum2 = "0"
                if (this.nextNewNum1 === "") this.nextNewNum1 = "0"
                if (this.nextNewNum4 === "") this.nextNewNum4 = "0"
                if (this.nextNewNum5 === "") this.nextNewNum5 = "0"
                Vue.axios
                    .post(`vatcutdeclarationextras`, {
                        accountBookId: this.$store.state.accountBook.id,
                        startPeriod: this.curData.startPeriod,
                        endPeriod: this.curData.endPeriod,
                        no: this.newSeri2,
                        type: this.nextNewType,
                        totalBalance: this.nextNewNum1,
                        actualBalance: this.nextNewNum2,
                        totalTax: this.nextNewNum4,
                        actualTax: this.nextNewNum5,
                    })
                    .then(res => {
                        this.$emit("update");
                        this.nextNewNum1 = this.nextNewNum2 = this.nextNewNum4  = this.nextNewNum5 = "";
                        this.nextNewType = this.vatcuter[0].id;
                    });
            }
        } else {
            this.$message("亲,请将四种数额全部填写");
        }
    }
    // 附表四
    changeFour(row: Declaration.Data) {
        Vue.axios
            .post(`vatcutdeclarations`, row)
            .then(res => {
                this.$emit("update");
            })
            .catch(() => {
                this.$emit("update");
            });
    }

    changeDec(row: Declaration.Data) {
        Vue.axios
            .post(`vatcutdeclarations`, {
                accountBookId: row.accountBookId,
                id: row.id,
                startPeriod: row.startPeriod,
                endPeriod: row.endPeriod,
                no: row.no,
                type: row.type,
                initBalance: row.initBalance,
                balance: row.balance,
                actualBalance: row.actualBalance
            })
            .then(res => {
                this.$emit("update");
            })
            .catch(() => {
                this.$emit("update");
            });
    }

    changeDecCut(row: any,name?:string) {
        if(name === "changeRow"){
            row.actualTax =((+row.totalBalance) - (+row.actualBalance))*0.03
        }
        this.$nextTick(()=>{
         Vue.axios
            .post(`vatcutdeclarationextras`, {
                accountBookId: row.accountBookId,
                actualBalance: row.actualBalance,
                actualTax: row.actualTax,
                endPeriod: row.endPeriod,
                extraBalance: row.extraBalance,
                gmtCreate: row.gmtCreate,
                gmtModified: row.gmtModified,
                id: row.id,
                no: row.no,
                startPeriod: row.startPeriod,
                totalBalance: row.totalBalance,
                totalTax: row.totalTax,
                type: row.type,
            })
            .then(res => {
                this.$emit("update");
            })
            .catch(() => {
                this.$emit("update");
            });
        })
    }
    // 修改表格数据
    changeInput(row: any) {
        Vue.axios
            .post(`inputtaxdetails/save`, row)
            .then(res => {
                this.$emit("update");
            })
            .catch(() => {
                this.$emit("update");
            });
    }

    normalMainSave(row: any) {
        Vue.axios.post(`generaltaxpayervatdeclaration/save`, {
            accountBookId: this.$store.state.accountBook.id,
            period: this.curData.endPeriod,
            row: row.col,
            data: row.val1
        }).then((res: any) => {
            this.$emit("update");
        }).catch(() => {
            this.$emit("update");
        })
    }
    // 修改附表一
    changeSales(row: any, col: number, i: number) {
        row.modifiedColumn = col;
        Vue.axios
            .post(`salesdetails`, row)
            .then(res => {
                this.$emit("update");
            })
            .catch(() => {
                this.$emit("update");
            });
    }

    // 附表三
    appendix3 = Appendix3;
}
